/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CoordinateSystem from './CoordinateSystem';
import ProblemData from './ProblemData';
import TimeSettings from './TimeSettings';

/**
 * The ProblemRequest model module.
 * @module model/ProblemRequest
 * @version 0.0.2
 */
class ProblemRequest {
    /**
     * Constructs a new <code>ProblemRequest</code>.
     * The Problem object embedded within the main solve request.
     * @alias module:model/ProblemRequest
     * @param problemType {module:model/ProblemRequest.ProblemTypeEnum} 
     * @param problemData {module:model/ProblemData} 
     */
    constructor(problemType, problemData) { 
        
        ProblemRequest.initialize(this, problemType, problemData);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, problemType, problemData) { 
        obj['problemType'] = problemType;
        obj['problemData'] = problemData;
    }

    /**
     * Constructs a <code>ProblemRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProblemRequest} obj Optional instance to populate.
     * @return {module:model/ProblemRequest} The populated <code>ProblemRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProblemRequest();

            if (data.hasOwnProperty('problemType')) {
                obj['problemType'] = ApiClient.convertToType(data['problemType'], 'String');
            }
            if (data.hasOwnProperty('problemData')) {
                obj['problemData'] = ProblemData.constructFromObject(data['problemData']);
            }
            if (data.hasOwnProperty('timeSettings')) {
                obj['timeSettings'] = TimeSettings.constructFromObject(data['timeSettings']);
            }
            if (data.hasOwnProperty('coordinateSystem')) {
                obj['coordinateSystem'] = CoordinateSystem.constructFromObject(data['coordinateSystem']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ProblemRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ProblemRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ProblemRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['problemType'] && !(typeof data['problemType'] === 'string' || data['problemType'] instanceof String)) {
            throw new Error("Expected the field `problemType` to be a primitive type in the JSON string but got " + data['problemType']);
        }
        // validate the optional field `problemData`
        if (data['problemData']) { // data not null
          ProblemData.validateJSON(data['problemData']);
        }
        // validate the optional field `timeSettings`
        if (data['timeSettings']) { // data not null
          TimeSettings.validateJSON(data['timeSettings']);
        }

        return true;
    }


}

ProblemRequest.RequiredProperties = ["problemType", "problemData"];

/**
 * @member {module:model/ProblemRequest.ProblemTypeEnum} problemType
 */
ProblemRequest.prototype['problemType'] = undefined;

/**
 * @member {module:model/ProblemData} problemData
 */
ProblemRequest.prototype['problemData'] = undefined;

/**
 * @member {module:model/TimeSettings} timeSettings
 */
ProblemRequest.prototype['timeSettings'] = undefined;

/**
 * @member {module:model/CoordinateSystem} coordinateSystem
 */
ProblemRequest.prototype['coordinateSystem'] = undefined;





/**
 * Allowed values for the <code>problemType</code> property.
 * @enum {String}
 * @readonly
 */
ProblemRequest['ProblemTypeEnum'] = {

    /**
     * value: "pickup-delivery"
     * @const
     */
    "pickup-delivery": "pickup-delivery",

    /**
     * value: "vehicle-routing"
     * @const
     */
    "vehicle-routing": "vehicle-routing"
};



export default ProblemRequest;

